<template>
  <Teleport to="body">
    <div class="fixed top-4 right-4 z-[100] flex flex-col gap-3 pointer-events-none">
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          :class="[
            'pointer-events-auto flex items-center gap-3 px-4 py-3 rounded-xl shadow-lg border backdrop-blur-sm min-w-[300px] max-w-[420px]',
            toast.type === 'success' ? 'bg-green-50/95 border-green-200 dark:bg-green-900/80 dark:border-green-700' :
            toast.type === 'error' ? 'bg-red-50/95 border-red-200 dark:bg-red-900/80 dark:border-red-700' :
            'bg-blue-50/95 border-blue-200 dark:bg-blue-900/80 dark:border-blue-700'
          ]"
        >
          <!-- Icon -->
          <div :class="[
            'h-8 w-8 rounded-full flex items-center justify-center shrink-0',
            toast.type === 'success' ? 'bg-green-100 dark:bg-green-800' :
            toast.type === 'error' ? 'bg-red-100 dark:bg-red-800' :
            'bg-blue-100 dark:bg-blue-800'
          ]">
            <!-- Success checkmark -->
            <svg v-if="toast.type === 'success'" class="h-4 w-4 text-green-600 dark:text-green-300" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
            <!-- Error X -->
            <svg v-else-if="toast.type === 'error'" class="h-4 w-4 text-red-600 dark:text-red-300" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
            <!-- Info i -->
            <svg v-else class="h-4 w-4 text-blue-600 dark:text-blue-300" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
            </svg>
          </div>

          <!-- Message -->
          <p :class="[
            'text-sm font-medium flex-1',
            toast.type === 'success' ? 'text-green-800 dark:text-green-200' :
            toast.type === 'error' ? 'text-red-800 dark:text-red-200' :
            'text-blue-800 dark:text-blue-200'
          ]">
            {{ toast.message }}
          </p>

          <!-- Dismiss -->
          <button
            @click="toastStore.dismiss(toast.id)"
            class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 shrink-0"
          >
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useToastStore } from '@/stores/toast';

const toastStore = useToastStore();
const toasts = computed(() => toastStore.toasts);
</script>

<style scoped>
.toast-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.toast-leave-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 1, 1);
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(80px);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(80px);
}
.toast-move {
  transition: transform 0.3s ease;
}
</style>
